import graphql__a4f1f861ed81ba779190 from "./__generated__/PageSectionPagesList_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import ButtonLink from "../Buttons/ButtonLink";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";

const PageSectionPagesList = props => {
  const { title, iconClass, description, resourceTargets } = props.pageSection;

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName={iconClass}
    >
      <ul className="pages-list list-unstyled boxes-list">
        {resourceTargets.map(resourceTarget => (
          <li key={resourceTarget.id}>
            <ButtonLink
              href={resourceTarget.url}
              className="btn btn-primary-inverse btn-block-md box-shadow"
              label={resourceTarget.name}
              iconClassName="icon-arrow-right"
              iconPosition="after"
              innerClassName="text-default"
            />
          </li>
        ))}
      </ul>
    </PageSectionBlockWithTitleAndDescription>
  );
};

export default createFragmentContainer(PageSectionPagesList, {
  pageSection: graphql__a4f1f861ed81ba779190
});
